import { render, staticRenderFns } from "./CompetencyGridsPage.vue?vue&type=template&id=74ebcb66"
import script from "./CompetencyGridsPage.vue?vue&type=script&lang=js"
export * from "./CompetencyGridsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports